if (!customElements.get('snack-hero-slider')) {
  class SnackHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.snack-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.snack-hero__dot'));
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.speed = (Number(this.dataset.speed) || 5) * 1000;
      this.timer = null;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      if (this.autoplay) this.start();

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay) this.start();
      });
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => {
        if (this.autoplay) this.start();
      });
    }

    disconnectedCallback() {
      this.stop();
    }

    goTo(index) {
      if (!this.slides.length) return;
      const next = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('hidden');
        else slide.setAttribute('hidden', '');
      });
      this.dots.forEach((dot, i) => {
        const active = i === next;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.index = next;
      if (this.autoplay) this.start();
    }

    next() {
      this.goTo(this.index + 1);
    }

    start() {
      this.stop();
      if (this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.next(), this.speed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  customElements.define('snack-hero-slider', SnackHeroSlider);
}
